import { jsx as _jsx } from "react/jsx-runtime";
export const SvgMap = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'm9 16.5-6 3V7.1L9 4l6 3 6-3v12.5l-6 3zM9 4v12.5M15 7v12.5' }) }));
//# sourceMappingURL=map.js.map